import React from 'react';

import SpotWorkersContext from '../../services/spotWorkers/SpotWorkersContext';
import Tippy from '../ReactTippy';

import { Confirmation, Information } from '../modals/common/';

import {
  isPartnerCompanyRoleId,
  isPrimaryCompanyRoleId,
} from '../../utilities/roleUtility';
import { SPOT_WORKER_RESIDENCE_TYPE } from '../../utilities/constants';
import masterSlideLoader from '../../utilities/masterSlideLoader';

import Styles from '../../styles/componentStyle/spotWorkers/spotWorkers.scss';
import InfinityScrollLoad from '../InfinityScrollLoad';
import { Description } from '../../components/Description';

/**
 * 現場常駐社員・非常駐入退場者一覧のヘッダー
 */
export default class SpotWorkersHeader extends React.Component {
  renderVisibleThumbnailsCheckbox(isVisibleThumbnails, toggleThumbnails) {
    return (
      <label htmlFor='check' className='checkbox thumbnail-toggler'>
        <input
          type='checkbox'
          id='check'
          name='isVisibleThumbnails'
          checked={isVisibleThumbnails}
          onChange={toggleThumbnails}
        />
        <i className='i-square i-3x' aria-hidden='true' />
        <span className='form-list__item-text'>{data.toggleThumbnails}</span>
      </label>
    );
  }

  // 画面表示
  render() {
    return (
      <SpotWorkersContext.Consumer>
        {({
          state,
          closeDialog,
          closeErrorDialog,
          handleRegisterResidentWorkersMenuButtonClicked,
          handleRegisterResidentWorkersConfirmButtonClicked,
          handleRegistrationCompleteCloseButtonClicked,
          handleDeleteSpotWorkersConfirmButtonClicked,
          isRegisterResidentWorkersDialogEnabled,
          isRegistrationCompleteDialogEnabled,
          isDeleteSpotWorkersDialogEnabled,
          canExecuteIntegration,
          toggleThumbnails,
          executeIntegration,
          showDeleteSpotWorkersDialog,
        }) => (
          <React.Fragment>
            <div className='header'>
              <ul className='btn-menu'>
                {this.props.spotWorkerType ===
                  SPOT_WORKER_RESIDENCE_TYPE.RESIDENT && (
                  <li className='btn-menu__item'>
                    <button
                      className='btn-fixedsize'
                      onClick={() => {
                        handleRegisterResidentWorkersMenuButtonClicked();
                      }}
                    >
                      {data.button.registerResidentWorkers}
                    </button>
                  </li>
                )}
                {this.props.spotWorkerType ===
                  SPOT_WORKER_RESIDENCE_TYPE.NON_RESIDENT && (
                  <li className='btn-menu__item'>
                    <button
                      className='btn-fixedsize'
                      onClick={() => {
                        masterSlideLoader.show('SpotWorkerNew', { state: {} });
                      }}
                    >
                      {data.button.registerNonResidentWorker}
                    </button>
                  </li>
                )}
                <li className='btn-menu__item'>
                  <button
                    className='btn-fixedsize--negative'
                    onClick={() => showDeleteSpotWorkersDialog()}
                  >
                    {data.button.deleteSelected}
                  </button>
                </li>
              </ul>
            </div>
            <div className='header'>
              <Description>
                {isPrimaryCompanyRoleId(state.roleId) && (
                  <button
                    className='btn-fixedsize--effective'
                    disabled={canExecuteIntegration() === false}
                    onClick={() => executeIntegration()}
                  >
                    {data.button.integration}
                  </button>
                )}
                {data.description}
              </Description>
            </div>
            <div className='header'>
              <ul className='btn-menu'>
                {(isPrimaryCompanyRoleId(state.roleId) ||
                  isPartnerCompanyRoleId(state.roleId)) && (
                  <li className='btn-menu__item'>
                    {this.renderVisibleThumbnailsCheckbox(
                      state.isVisibleThumbnails,
                      toggleThumbnails
                    )}
                  </li>
                )}
              </ul>

              <Confirmation
                visible={isRegisterResidentWorkersDialogEnabled()}
                title={data.registerResidentWorkersDialog.title}
                confirmButtonText={
                  data.registerResidentWorkersDialog.confirmButton
                }
                cancelButtonText={
                  data.registerResidentWorkersDialog.cancelButton
                }
                message={<RegisterResidentWorkersDialog />}
                isNegative={true}
                onCancel={() => closeDialog()}
                onConfirm={() =>
                  handleRegisterResidentWorkersConfirmButtonClicked()
                }
                rootClassName={Styles.registerResidentWorkersDialog}
                negativeButtonClassName={'btn--effective'}
              />

              <Confirmation
                visible={isDeleteSpotWorkersDialogEnabled()}
                confirmButtonText={data.deleteSpotWorkersDialog.confirmButton}
                cancelButtonText={data.deleteSpotWorkersDialog.cancelButton}
                message={
                  this.props.spotWorkerType ===
                  SPOT_WORKER_RESIDENCE_TYPE.RESIDENT
                    ? data.deleteSpotWorkersDialog.messageForResident
                    : data.deleteSpotWorkersDialog.messageForNonResident
                }
                isNegative={true}
                onCancel={() => closeDialog()}
                onConfirm={() => handleDeleteSpotWorkersConfirmButtonClicked()}
                rootClassName={Styles.deleteSpotWorkersDialog}
                negativeButtonClassName={'btn--negative'}
              />

              <Information
                visible={isRegistrationCompleteDialogEnabled()}
                title={data.registrationCompleteDialog.title}
                buttonText={data.registrationCompleteDialog.closeButton}
                message={data.registrationCompleteDialog.message}
                isNegative={true}
                onClose={() => handleRegistrationCompleteCloseButtonClicked()}
                rootClassName={Styles.registrationCompleteDialog}
                multilineText={true}
              />

              <Information
                rootClassName={
                  state.errorDialog.message &&
                  state.errorDialog.message.length > 28
                    ? 'wide-dialog-md'
                    : ''
                }
                visible={state.errorDialog.enabled}
                message={state.errorDialog.message}
                buttonText={data.errorDialog.button}
                onClose={() => closeErrorDialog()}
                multilineText={!!state.errorDialog.title}
                title={state.errorDialog.title}
              />
            </div>
          </React.Fragment>
        )}
      </SpotWorkersContext.Consumer>
    );
  }
}

/**
 * 現場に招待された社員を登録ダイアログ
 * */
const RegisterResidentWorkersDialog = () => {
  const renderTableBody = (users, selectedUserIds, userSelectedHandler) => {
    return users.map((user, index) => (
      <tr
        className='table__item'
        key={index}
        onClick={() => userSelectedHandler(user)}
      >
        <td className='value-table'>
          <div className='value-table__icon'>
            <label className='checkbox'>
              <input
                type='checkbox'
                checked={selectedUserIds.includes(user.user_id)}
                onClick={() => userSelectedHandler(user)}
              />
              <i className='i-square i-3x' />
            </label>
          </div>
        </td>
        <td className='value-table role'>
          <div className='value-table__name'>{user.role_name}</div>
        </td>
        <td className='value-table fullname'>
          <div className='value-table__name'>
            <WithTooltip>{user.fullname}</WithTooltip>
          </div>
        </td>
        <td className='value-table branch_name'>
          <div className='value-table__name'>
            <WithTooltip>{user.company_branch_name}</WithTooltip>
          </div>
        </td>
      </tr>
    ));
  };

  // 画面表示
  return (
    <SpotWorkersContext.Consumer>
      {({
        state,
        userSelectedHandler,
        unregisteredUsersInfiniteScrollLoad,
      }) => (
        <React.Fragment>
          <div className='help-message'>
            {data.registerResidentWorkersDialog.selectWorkersForRegistration}
          </div>
          <div className='scroll-container' id='infinityscroll-target-1'>
            <table className='table'>
              <thead className='table__header'>
                <tr className='table__label'>
                  <th className='value-table' />
                  {data.registerResidentWorkersDialog.tableTitles.map(
                    (title, index) => (
                      <th
                        className={`value-table value-table--table__label ${
                          title.name
                        }`}
                        key={index}
                      >
                        <span className='value-table__label'>
                          {title.label}
                        </span>
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody className='table__body'>
                {renderTableBody(
                  state.registerResidentWorkersDialog.users,
                  state.registerResidentWorkersDialog.selectedUserIds,
                  userSelectedHandler
                )}
              </tbody>
            </table>
            <InfinityScrollLoad
              targetId='infinityscroll-target-1'
              total={state.registerResidentWorkersDialog.total}
              callback={notify => {
                unregisteredUsersInfiniteScrollLoad(notify);
              }}
            />
          </div>
        </React.Fragment>
      )}
    </SpotWorkersContext.Consumer>
  );
};

const WithTooltip = ({ children, className }) => (
  <Tippy
    duration={10}
    distance={24}
    arrowType='sharp'
    delay={[100, 0]}
    placement='bottom'
    followCursor={true}
    html={<div className={Styles.toopTip}>{children}</div>}
  >
    <p className={className}>{children}</p>
  </Tippy>
);

// 定数
const data = {
  toggleThumbnails: '一覧に顔写真を表示する',
  button: {
    registerResidentWorkers: '現場に招待された社員を登録',
    registerNonResidentWorker: '新規登録',
    deleteSelected: '選択項目の削除',
    integration: '顔写真情報を機器に送信する',
  },
  registerResidentWorkersDialog: {
    title: '現場に招待された社員を登録',
    selectWorkersForRegistration:
      '現場常駐社員に登録したい社員を選択してください。',
    confirmButton: '選択した社員を登録',
    cancelButton: '登録をやめる',
    tableTitles: [
      { name: 'role', label: 'ユーザー種別' },
      { name: 'fullname', label: '氏名' },
      { name: 'branch_name', label: '支店名' },
    ],
    tableNoData: '対象データがありません',
  },
  registrationCompleteDialog: {
    title: '現場常駐社員登録完了',
    message:
      '選択した社員を現場常駐社員に登録しました。\n入退場の管理を行うには、顔写真の登録を行ってください。',
    closeButton: '閉じる',
  },
  deleteSpotWorkersDialog: {
    confirmButton: '削除',
    cancelButton: '戻る',
    messageForResident: '選択した常駐社員を削除しますか？',
    messageForNonResident: '選択した非常駐入退場者を削除しますか？',
  },
  errorDialog: {
    button: '戻る',
  },
  description: (
    <p>
      顔写真情報の登録・変更・削除があった場合は、夜間に変更内容が機器に自動で送信されます。
      <br />
      変更内容をすぐに機器に反映させたい場合は「顔写真情報を機器に送信する」をクリックしてください。
    </p>
  ),
};



// WEBPACK FOOTER //
// ./src/components/header/SpotWorkersHeader.jsx